import { Box, customStyled, Flex } from '@mafc/trolly';
import COLORS from 'theme/colors';

export const FreebieCartListItem = customStyled(Box)(props => ({
  padding: `16px 16px 20px`,
  position: 'relative',
  marginBottom: props.theme.space[3],
  borderRadius: props.theme.radii[3],
  background: props.theme.colors.white,
}));

export const Product = customStyled(Flex)(() => ({
  alignItems: 'start',
}));

export const FreebieProductTitle = customStyled(Box)(props => ({
  color: props.theme.colors.black,
  textTransform: 'capitalize',
  fontSize: props.theme.fontSizes[1],
  fontWeight: props.theme.fontWeights[6],
  margin: '8px 0 10px',
}));

export const FreebieText = customStyled(Box)(props => ({
  color: COLORS.GRAY_SCALE,
  fontSize: props.theme.fontSizes[1],
}));

export const ProductDetails = customStyled(Flex)(() => ({
  flexDirection: 'column',
  width: '100%',
}));

export const GiftItemWrapper = customStyled(Box)(() => ({
  position: 'absolute',
  top: '12px',
  right: '12px',
}));

export const FreebieLabelWraper = customStyled(Box)(props => ({
  position: 'absolute',
  top: '0',
  left: '0',
  width: '56',
  height: `${props.theme.heights[0]}px`,
  color: props.theme.colors.white,
  padding: `0 ${props.theme.space[2]}px`,
  fontSize: props.theme.fontSizes[0],
  fontWeight: props.theme.fontWeights[6],
  lineHeight: `${props.theme.heights[0]}px`,
  backgroundColor: props.theme.colors.persiangreen,
  borderRadius: '12px 0',
}));
